import { DATA_PATHS } from '@lib/constants';
import Icon from '@components/common/Icon';

const CVSection = () => {
  const highlights = [
    {
      icon: 'chess',
      title: 'Chess Achievements',
      description: '3x National Champion, National Master Title, International Tournaments',
    },
    {
      icon: 'robotics',
      title: 'Robotics Leadership',
      description: 'FRC Rookie Inspiration Award, VEX Excellence Award, Team Captain',
    },
    {
      icon: 'academics',
      title: 'Academic Excellence',
      description: 'National Honor Society, AP Scholar with Distinction, Math Honors',
    },
    {
      icon: 'social-impact',
      title: 'Social Impact',
      description: '$4000+ Raised, 100+ Students Mentored, Prison Chess Program',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8 sm:mb-12">
          <h2
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-3 sm:mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Curriculum Vitae
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            A comprehensive overview of my academic achievements, competitive successes,
            and leadership experiences.
          </p>
        </div>

        {/* CV Highlights Grid - Mobile: horizontal scroll, Desktop: grid */}
        <div className="sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:gap-6 flex sm:flex-none overflow-x-auto gap-4 snap-x snap-mandatory scrollbar-hide pb-4 sm:pb-0 -mx-4 px-4 sm:mx-0 mb-8 sm:mb-12">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className="p-5 sm:p-6 rounded-lg text-center transition-all duration-300 hover:shadow-card-hover flex-shrink-0 w-[70vw] sm:w-auto snap-center"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'var(--color-card-border)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-hover-border)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-border)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="flex justify-center mb-3 sm:mb-4">
                <div
                  className="w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'var(--color-accent-1)' }}
                >
                  <Icon
                    name={highlight.icon}
                    size="md"
                    className="sm:hidden"
                    style={{ color: 'var(--color-accent-7)' }}
                  />
                  <Icon
                    name={highlight.icon}
                    size="lg"
                    className="hidden sm:block"
                    style={{ color: 'var(--color-accent-7)' }}
                  />
                </div>
              </div>
              <h3
                className="text-base sm:text-lg font-bold mb-2"
                style={{ color: 'var(--color-heading)' }}
              >
                {highlight.title}
              </h3>
              <p
                className="text-xs sm:text-sm leading-relaxed"
                style={{ color: 'var(--color-subtle)' }}
              >
                {highlight.description}
              </p>
            </div>
          ))}
        </div>

        {/* CV Preview Card */}
        <div
          className="rounded-lg sm:rounded-xl overflow-hidden"
          style={{
            backgroundColor: 'var(--color-card-bg)',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'var(--color-card-border)',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          {/* PDF Preview */}
          <div className="relative w-full h-96 sm:h-[600px]">
            <iframe
              src={DATA_PATHS.CV}
              className="w-full h-full"
              title="Curriculum Vitae"
              style={{
                border: 'none',
                backgroundColor: 'var(--color-theme-2)',
              }}
            />
          </div>

          {/* Download button */}
          <div className="p-4 sm:p-6 text-center" style={{ backgroundColor: 'var(--color-theme-1)' }}>
            <a
              href={DATA_PATHS.CV}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-medium rounded-lg transition-all duration-200 px-5 sm:px-6 py-2.5 sm:py-3 text-base sm:text-lg shadow-card hover:shadow-card-hover"
              style={{
                backgroundColor: 'var(--color-button-primary-bg)',
                color: 'var(--color-button-primary-text)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--color-button-primary-hover)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--color-button-primary-bg)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg
                className="w-4 h-4 sm:w-5 sm:h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span className="hidden sm:inline">Download Complete CV</span>
              <span className="sm:hidden">Download CV</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CVSection;
